import { ArrayNotEmpty, IsArray, IsNotEmpty, IsOptional } from "class-validator";

export class StudyFilterModel {
  @IsNotEmpty()
  public dateTimeStart: string;

  @IsNotEmpty()
  public dateTimeEnd: string;

  @IsOptional()
  public time: string | number;

  @IsOptional()
  public patientIdOrName: string | number;

  @IsOptional()
  public reportStatuses: (number | string)[];

  @IsOptional()
  public priorities: (number | string)[];

  @IsArray()
  @ArrayNotEmpty()
  public modalities: string[];

  @IsOptional()
  public size: number;

  @IsOptional()
  public page: number;

  @IsOptional()
  public clinicalProtocolId: number;

  @IsOptional()
  public existsClinicalNotes: boolean | string;

  @IsOptional()
  public existsAttachFiles: boolean | string;

  @IsOptional()
  public requestDoctorId: string | number;

  @IsOptional()
  public receivingAet: string;

  @IsOptional()
  public sendingAet: string;

  @IsOptional()
  public defaultSortOrder: string | number;

  @IsOptional()
  public defaultMode: string | number;

  @IsOptional()
  public referenceDate: string | number;

  @IsOptional()
  public onlyExamsRequestedByMe: boolean = false;

  @IsOptional()
  public background: boolean = false;

  constructor(data: Partial<StudyFilterModel> = {}) {
    this.dateTimeStart = data.dateTimeStart ?? "";
    this.dateTimeEnd = data.dateTimeEnd ?? "";
    this.time = data.time ?? null;
    this.patientIdOrName = data.patientIdOrName ?? "";
    this.reportStatuses = data.reportStatuses ?? [];
    this.priorities = data.priorities ?? [];
    this.modalities = data.modalities ?? [];
    this.size = data.size ?? 30;
    this.page = data.page ?? 0;
    this.clinicalProtocolId = data.clinicalProtocolId ?? null;
    this.existsClinicalNotes = data.existsClinicalNotes ?? "";
    this.existsAttachFiles = data.existsAttachFiles ?? "";
    this.requestDoctorId = data.requestDoctorId ?? "";
    this.receivingAet = data.receivingAet ?? "";
    this.sendingAet = data.sendingAet ?? "";
    this.defaultSortOrder = data.defaultSortOrder ?? "";
    this.defaultMode = data.defaultMode ?? "";
    this.referenceDate = data.referenceDate ?? "";
    this.onlyExamsRequestedByMe = data.onlyExamsRequestedByMe ?? false;
    this.background = data.background ?? false;
  }

  public setBackground(value: boolean): void {
    this.background = value;
  }

  public setTime(value: string | number): void {
    this.time = value;
  }

  public setReportStatuses(value: (number | string)[]): void {
    this.reportStatuses = value;
  }

  public setModalities(value: string[]): void {
    this.modalities = value;
  }

  public setSize(value: number): void {
    this.size = value;
  }

  public setDefaultSortOrder(value: string | number): void {
    this.defaultSortOrder = value;
  }

  public setDefaultMode(value: string | number): void {
    this.defaultMode = value;
  }

  public setReferenceDate(value: string | number): void {
    this.referenceDate = value;
  }

  public setOnlyExamsRequestedByMe(value: boolean): void {
    this.onlyExamsRequestedByMe = value;
  }

  public setRequestDoctorId(value: string | number): void {
    this.requestDoctorId = value;
  }

  public setPriorities(value: (number | string)[]): void {
    this.priorities = value;
  }
}
